import { useAuth0 } from '@auth0/auth0-react';
import { useEffect, useState } from 'react';

export const useUserMetadata = () => {
  const { user, getIdTokenClaims } = useAuth0();
  const [metadata, setMetadata] = useState(null);

  useEffect(() => {
    const getTokenAndMetadata = async () => {
      if (!user) {
        setMetadata(null);
        return;
      }

      try {
        const idTokenClaims = await getIdTokenClaims();
        if (!idTokenClaims) {
          setMetadata(null);
          return;
        }
        const namespace = 'https://myapp.azmed.co/';
        setMetadata(idTokenClaims[`${namespace}app_metadata`]);
      } catch (err) {
        console.error('Erreur lors de la récupération du token:', err);
      }
    };

    getTokenAndMetadata();
  }, [getIdTokenClaims, user]);

  return { metadata };
};
